import { useModal } from '../../../../hooks/useModal';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { useTranslation } from '../../../../translations';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';
import { defaultStore, stores } from '../../../../translations';
import classNames from 'classnames';

export const PremiumOffer = ({ callbacks }) => {
  const { t } = useTranslation();
  const { addModal } = useModal();
  const { language } = useLanguageControls();

  const onClick = () => {
    addModal({ type: 'passModal', props: { callbacks } });
  };

  return (
    <div className={'task__premium-offer'}>
      <div className={'task__premium-offer-content'}>
        <h3 className={'task__premium-offer-title'}>{safeHTML(t('task.premiumOffer.text'))}</h3>
        <p className={'task__premium-offer-text'}>{safeHTML(t('task.premiumOffer.description'))}</p>
        <CustomButton
          text={'other.buy'}
          className={classNames('task__premium-offer-button', 'button_task', 'button_task-premium', {
            'task__premium-offer-button_kz': defaultStore !== stores.ru,
          })}
          onClick={onClick}
        />
      </div>
    </div>
  );
};
